<div class="container">
  <div class="job-listing">
    <nz-tabset nzCentered>
      <nz-tab nzTitle="Featured Careers">
        <div nz-row [nzGutter]="[2, 2]" class="mx-2">
          @for (item of feautureCareers; track item) {
            <div
              nz-col
              nnzXs="24"
              nzSm="12"
              nzMd="12"
              nzLg="6"
              class="job-listing__container gutter-row"
              >
              <a
                routerLink="/job-preview/{{ item.jobRequestId }}"
                class="job-listing__container-item web"
                >
                <ng-container *ngTemplateOutlet="cardDetails; context: { $implicit: item }"
                 />
              </a>
              <a
                routerLink="/job-preview/{{ item.jobRequestId }}"
                target="_SEJ"
                rel="noreferrer"
                class="job-listing__container-item mobile"
                >
                <ng-container *ngTemplateOutlet="cardDetails; context: { $implicit: item }"
                 />
              </a>
            </div>
          }
        </div>
      </nz-tab>
      <nz-tab nzTitle="Newest Listing">
        <div nz-row [nzGutter]="[2, 2]" class="mx-2">
          @for (item of newestListings; track item) {
            <div
              nz-col
              nnzXs="24"
              nzSm="12"
              nzMd="12"
              nzLg="6"
              class="job-listing__container gutter-row"
              >
              <a
                routerLink="/job-preview/{{ item.jobRequestId }}"
                class="job-listing__container-item web"
                >
                <ng-container *ngTemplateOutlet="cardDetails; context: { $implicit: item }"
                 />
              </a>
              <a
                routerLink="/job-preview/{{ item.jobRequestId }}"
                target="_SEJ"
                rel="noreferrer"
                class="job-listing__container-item mobile"
                >
                <ng-container *ngTemplateOutlet="cardDetails; context: { $implicit: item }"
                 />
              </a>
            </div>
          }
        </div>
      </nz-tab>
    </nz-tabset>
  </div>
</div>

<ng-template #cardDetails let-item>
  <i
    class="jobs-icon"
    [ngClass]="getIconCategory(item.category)"
    nz-tooltip
    nzTooltipPlacement="right"
    [nzTooltipTitle]="item.category"
    >
  </i>
  <h1>{{ item.postingTitle }}</h1>
  <h3 [innerHTML]="changeLocationStr(item.workLocation)"></h3>
  <p>
    {{ getCardAge(item.dateOpened) }}
  </p>
  <button
    (click)="applyJr(item.jobRequestId, $event)"
    nz-button
    nzType="primary"
    nzSize="large"
    nzShape="round"
		class="GA-apply-btn"
    [disabled]="checkAppliedJr(item.jobRequestId)"
    >
    @if (!checkAppliedJr(item.jobRequestId)) {
      Apply
    }
    @if (checkAppliedJr(item.jobRequestId)) {
      Applied
    }
  </button>
</ng-template>
